<template>
  <div class="result-card">
    <img
      v-if="image"
      class="result-card__image"
      :src="image"
      alt=""
    >
    <v-icon
      v-else-if="icon"
      class="result-card__icon"
      :color="iconColor"
      size="48"
    >
      {{ icon }}
    </v-icon>

    <h1 class="result-card__title">
      {{ title }}
    </h1>

    <slot />

    <p v-if="text" class="result-card__text">
      {{ text }}
    </p>
    <p v-if="note" class="result-card__note">
      {{ note }}
    </p>

    <v-btn
      class="result-card__btn"
      x-large
      depressed
      @click="$emit('action')"
    >
      {{ actionLabel }}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'ResultCard',
    props: {
      image: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      iconColor: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        default: '',
      },
      note: {
        type: String,
        default: '',
      },
      actionLabel: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="less" scoped>
.result-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 420px;
  padding: 40px;
  background-color: #fff;
  border-radius: 8px;
  text-align: center;

  &__icon {
    margin-bottom: 16px;
  }

  &__image {
    width: 100%;
    max-width: 200px;
    height: auto;
    margin-bottom: 20px;
  }

  &__title {
    font-size: 28px;
    font-weight: 500;
    line-height: 1.2;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 8px;
  }

  &__text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 8px;
  }

  &__note {
    margin: 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.38);
  }

  &__btn.v-btn {
    margin-top: 32px;
    padding: 0 48px;
    background-color: @color-primary !important;
    color: #fff !important;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    text-transform: none;
    letter-spacing: normal;
  }
}
</style>
